import { useContext } from 'react';
import AuthContext from '../contexts/authentication/AuthProvider';
import { PermissionLevel } from '../types/claims/profilePermission';

export interface Area {
  tag: string;
  nombre: string;
  nivelPermiso: PermissionLevel | undefined;
}

export interface AreaFilter {
  tag: string;
  nombre: string;
  filtroActivo: boolean;
}

export const useRoleDescriptionPermissions = () => {
  const { user } = useContext(AuthContext);
  const allAreas: Area[] = [
    {
      tag: 'Mantencion',
      nombre: 'Mantención',
      nivelPermiso: user?.claims?.['DCMantencion'],
    },
    {
      tag: 'Planificacion',
      nombre: 'Planificación',
      nivelPermiso: user?.claims?.['DCPlanificacion'],
    },
    {
      tag: 'RRHH',
      nombre: 'RRHH',
      nivelPermiso: user?.claims?.['DCRRHH'],
    },
    {
      tag: 'Operaciones',
      nombre: 'Operaciones',
      nivelPermiso: user?.claims?.['DCOperaciones'],
    },
    {
      tag: 'Finanzas',
      nombre: 'Finanzas',
      nivelPermiso: user?.claims?.['DCFinanzas'],
    },
    {
      tag: 'Logistica',
      nombre: 'Logística',
      nivelPermiso: user?.claims?.['DCLogistica'],
    },
    {
      tag: 'Electromovilidad',
      nombre: 'Electromovilidad',
      nivelPermiso: user?.claims?.['DCElectromovilidad'],
    },
    {
      tag: 'Combustible',
      nombre: 'Combustible',
      nivelPermiso: user?.claims?.['DCCombustible'],
    },
    {
      tag: 'Prevencion',
      nombre: 'Prevención y Seguridad',
      nivelPermiso: user?.claims?.['DCPrevencionySeguridad'],
    },
  ];
  const areas = allAreas.filter(
    (area) =>
      area.nivelPermiso !== undefined &&
      area.nivelPermiso !== PermissionLevel.None
  );
  const areaFilters: AreaFilter[] = allAreas.map((ae) => ({
    tag: ae.tag,
    nombre: ae.nombre,
    filtroActivo: false,
  }));
  return { areas, areaFilters };
};
